import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators';
import { CommonService } from '../../common/services/common.service';

@Injectable()
export class HomeService {

  searchResults = new BehaviorSubject<any>({});

  returnsearchResults = new BehaviorSubject<any>({});


  popularDeals = new BehaviorSubject<any>({});

  constructor(private _http: HttpClient, private _commonService: CommonService) { }

  setSearchResults(results) {
    this.searchResults.next(results);
  }

  setReturnSearchReuslts(results){
    this.returnsearchResults.next(results);
  }

  setPopularDeals(results){
    this.popularDeals.next(results);
  }

  searchFlights(params) {
    return(this._http.post(this._commonService.baseUrl + 'airpool/search', params));
  }

  lastMinuteDeals(){
    return(this._http.get(this._commonService.baseUrl + 'home/getlastminutedeals'));
  }

  getBlogPost(param){
    const headers: HttpHeaders = new HttpHeaders();
    return(this._http.get(this._commonService.baseUrl + 'blog/'+param,{ headers: headers, responseType: 'json' })).pipe(
      map((res: Response) => res.json())
      );;
  }


  getDynamicPages(){
    return(this._http.get(this._commonService.baseUrl+'getdynamicpages'));
  }

  getDynamicPageDetail(id:any){
    return(this._http.get(this._commonService.baseUrl+'getdynamicpage/'+id));
  }

  getHomePageBlogPosts(){
    return(this._http.get(this._commonService.baseUrl+'getblogs'));
  }

  getallBlogPosts(){
    return(this._http.get(this._commonService.baseUrl+'getallblogs'));
  }

  getAirportList(params) {
    
    return (this._http.post(this._commonService.baseUrl + 'airpool/airports', params));
  }

}
